import { Popover } from '@material-ui/core'
import React from 'react'
import { FieldProps, FormDataConsumer, TextInput } from 'react-admin'
import { ChromePicker } from 'react-color'
import { useField } from 'react-final-form'
import { getContrastColor } from '../../core/common/visual.utils'

interface ColorPickerProps extends FieldProps {
  source: string
}

export const RAColorPicker = (props: ColorPickerProps) => {
  const { record, source } = props

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const pickerOpen = Boolean(anchorEl)

  const handleOpenPicker = (event) => {
    setAnchorEl(event?.currentTarget)
  }

  const handleClosePicker = () => {
    setAnchorEl(null)
  }

  const {
    input: { onChange },
    meta: { touched, error },
  } = useField(source)

  return (
    <FormDataConsumer>
      {({ formData }) => (
        <>
          <TextInput
            {...props}
            error={!!(touched && error)}
            helperText={(touched && error) ?? ' '}
            onClick={handleOpenPicker}
            InputProps={{
              style: {
                color:
                  record?.[source] || formData?.[source]
                    ? getContrastColor(formData?.[source] ?? record?.[source])
                    : undefined,
                backgroundColor: formData?.[source] ?? record?.[source],
              },
            }}
            InputLabelProps={{
              style: {
                color:
                  record?.[source] || formData?.[source]
                    ? getContrastColor(formData?.[source] ?? record?.[source])
                    : undefined,
              },
            }}
            aria-describedby="ra-chroma-picker"
          />
          <Popover
            id="ra-chroma-picker"
            open={pickerOpen}
            anchorEl={anchorEl}
            onClose={handleClosePicker}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <ChromePicker
              color={formData?.[source] ?? record?.[source] ?? '#000000'}
              onChange={({ hex }) => onChange?.(hex)}
            />
          </Popover>
        </>
      )}
    </FormDataConsumer>
  )
}
